import { Col, Row } from "antd";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import AddPos from "./AddPos";
import ProductsForSale from "./ProductsForSale";
import "./pos.css";

const Sale = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const [selectedProds, setSelectedProds] = useState([]);

	const handleSelectedProds = (prod) => {
		const foundProd = selectedProds.find((item) => item.id === prod.id);
		if (foundProd === undefined) {
			setSelectedProds((prev) => [...prev, { ...prod, selectedQty: 1 }]);
		}
	};

	const handleSelectedProdsQty = (prodId, qty) => {
		const updatedSelectedProds = selectedProds.map((prod) => {
			let prodCopy;
			if (prod.id === prodId) {
				prodCopy = { ...prod, selectedQty: qty };
			} else prodCopy = { ...prod };

			return prodCopy;
		});

		setSelectedProds(updatedSelectedProds);
	};

	const handleSelectedProdsUnitPrice = (prodId, unitPrice) => {
		const updatedSelectedProds = selectedProds.map((prod) => {
			let prodCopy;
			if (prod.id === prodId) {
				prodCopy = { ...prod, sale_price: unitPrice };
			} else prodCopy = { ...prod };

			return prodCopy;
		});

		setSelectedProds(updatedSelectedProds);
	};

	const handleDeleteProd = (prodId) => {
		const updatedProd = selectedProds.filter((prod) => prod.id !== prodId);
		setSelectedProds(updatedProd);
	};

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	return (
		<div className="pos-page">
			<Row gutter={[20]} className="pos-page-row">
				<Col span={24} lg={13} xl={14} className="pos-products-col">
					<div className="pos-product-list-wrap">
						<ProductsForSale handleSelectedProds={handleSelectedProds} />
					</div>
				</Col>
				<Col span={24} lg={11} xl={10} className="pos-form-col">
					<div className="pos-form-wrap">
						<AddPos
							selectedProds={selectedProds}
							handleSelectedProdsQty={handleSelectedProdsQty}
							handleSelectedProdsUnitPrice={handleSelectedProdsUnitPrice}
							handleDeleteProd={handleDeleteProd}
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default Sale;
